export default __webpack_public_path__ + "static/header-iconic-link-developers-icon3.url-a84ce35e0dc4a2ed637e56dc4e5007ff.svg";